export default "__VITE_ASSET__C_Sd5yPk__"